export default __webpack_public_path__ + "static/media/tc-audit-default-icon.9eb621fb.svg";